import { createSlice } from "@reduxjs/toolkit";

import {
  downloadInvoice,
  getCustomerSubscriptions } from "../actions"
import {
  getInvoices,
  getCustomerCard,
  updateCustomerCard
  } from "./actions"

const initialState = {
  loadedFirstTime: false,
  loading: false,
  invoicesObtained: false,
  invoices: [],
  subscriptionsObtained: false,
  subscriptions:[],
  downloadingId: null,
  downloadUrl: "",
  card:{},
  cardObtained: false,
};

const billingActivitySlice = createSlice({
  name: "billingActivity",
  initialState: initialState,
  reducers: {
    resetUrl: (state) => { state.downloadUrl = "" },
  },
  extraReducers: (builder) => {
    builder.addCase(getInvoices.fulfilled, (state, action)=>{
      state.loadedFirstTime = true;
      state.invoicesObtained = true;
      state.invoices = action.payload.success ? action.payload.data : []
    });
    builder.addCase(getInvoices.pending, (state) => {});
    builder.addCase(getInvoices.rejected, (action) => {});

    builder.addCase(getCustomerSubscriptions.fulfilled, (state, action) => {
      state.subscriptionsObtained = action.payload.subscriptionId ? false : true;
      state.subscriptions = action.payload.subscriptionId ? [] : action.payload.data;
    });
    builder.addCase(getCustomerSubscriptions.pending, (state) => { });
    builder.addCase(getCustomerSubscriptions.rejected, (state) => { });

    builder.addCase(downloadInvoice.fulfilled, (state, action) => {
      state.downloadingId = null;
      state.downloadUrl = action.payload.success ? action.payload.data.downloadUrl : "";
    });
    builder.addCase(downloadInvoice.pending, (state, action) => {
      state.downloadingId = action.meta.arg;
    });
    builder.addCase(downloadInvoice.rejected, (state) => {});

    builder.addCase(getCustomerCard.fulfilled, (state, action) => {
      state.cardObtained = true;
      state.card = action.payload.success ? action.payload.data : {}
    });
    builder.addCase(getCustomerCard.pending, (state, action) => {});
    builder.addCase(getCustomerCard.rejected, (state) => {});

    builder.addCase(updateCustomerCard.fulfilled, (state, action) => {
      state.loading = false;
      state.card = action.payload.success ? action.payload.data.card : state.card
    });
    builder.addCase(updateCustomerCard.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCustomerCard.rejected, (state) => {});
  }
})

export const { resetUrl } = billingActivitySlice.actions;
export default billingActivitySlice.reducer;